import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

import { AuthenticationService } from './services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    AuthenticationService
  ]
})
export class AppComponent implements OnInit {

  constructor(private AuthenticationService: AuthenticationService, private router: Router, private cookieService: CookieService) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
    });
    this.checkForCookies();
  }

  checkForCookies(): void {
    if(this.cookieService.check('perchedToken') && this.cookieService.check('perchedUser')){
      this.AuthenticationService.validateToken(this.cookieService.get('perchedToken')).subscribe((data: any) => {
        if(data.status == 'Valid Token' && this.router.url == '/about'){
          this.router.navigate(['/home']);
        }
        else if(data.status == 'Valid Token' && this.router.url){
          this.router.navigate([this.router.url]);
        }
        else {
          this.router.navigate(['/login']);
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/app.component.ts